import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import ToolbarLinkOrButton from './ToolbarLinkOrButton';
const ToolbarIconButton = t0 => {
  const $ = _c(18);
  const {
    badgeColor: t1,
    className: t2,
    count,
    "data-xc": dataXc,
    icon: Icon,
    iconHeight: t3,
    iconWidth: t4,
    onClick,
    to,
    title
  } = t0;
  const badgeColor = t1 === undefined ? "brand" : t1;
  const className = t2 === undefined ? "" : t2;
  const iconHeight = t3 === undefined ? 22 : t3;
  const iconWidth = t4 === undefined ? 24 : t4;
  const t5 = `items-center bg-transparent rounded-full border-2 border-solid border-transparent text-gray flex h-[38px] justify-center relative w-[38px] hover:text-brand focus:text-brand ${className}`;
  let t6;
  if ($[0] !== title) {
    t6 = <VisuallyHidden>{title}</VisuallyHidden>;
    $[0] = title;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== Icon || $[3] !== iconHeight || $[4] !== iconWidth || $[5] !== title) {
    t7 = !!Icon && <Icon title={title} color="currentColor" width={iconWidth} height={iconHeight} />;
    $[2] = Icon;
    $[3] = iconHeight;
    $[4] = iconWidth;
    $[5] = title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== badgeColor || $[8] !== count) {
    t8 = !!count && <div className={classNames("text-xs rounded-sm bottom-[5px] text-white inline-block font-bold h-[15px] absolute right-1 text-center w-[15px]", {
      "bg-brand": badgeColor === "brand",
      "bg-red": badgeColor === "red"
    })} aria-hidden={true}>{count}</div>;
    $[7] = badgeColor;
    $[8] = count;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== dataXc || $[11] !== onClick || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== to) {
    t9 = <ToolbarLinkOrButton className={t5} data-xc={dataXc} onClick={onClick} to={to}>{t6}{t7}{t8}</ToolbarLinkOrButton>;
    $[10] = dataXc;
    $[11] = onClick;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = to;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
ToolbarIconButton.propTypes = {
  badgeColor: PropTypes.oneOf(['brand', 'red']),
  className: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  'data-xc': PropTypes.string,
  icon: PropTypes.elementType,
  iconHeight: PropTypes.number,
  iconWidth: PropTypes.number,
  onClick: PropTypes.func,
  to: PropTypes.string,
  title: PropTypes.string
};
export default ToolbarIconButton;